"use client";

import { SearchHeader } from "./SearchPageHeader";
import { useSearchCounts } from "./SearchResults";
import type { RichtextStoryblok } from "@/generated/sb/sb-types";
import { withSearchParams } from "@/components/withSearchParams";
import type { StoryblokRichtext } from "@/storyblok-base";

interface SearchHeaderClientProps {
	title?: string;
	description?: StoryblokRichtext;
	preview: boolean;
}

export const SearchHeaderClient = withSearchParams<SearchHeaderClientProps>(
	({ title, description, preview, searchParams }) => {
		const counts = useSearchCounts(searchParams);

		return (
			<SearchHeader title={title} description={description} preview={preview} counts={counts} />
		);
	},
);
